<template>
  <section class="bottom">
    <div class="btn-con">
      <span class="gradient"></span>
      <button @click="openApp">打开APP，查看全部话题内容</button>
    </div>
    <img class="bg" src="../images/wap_bottom@3x.jpg" alt="download">
  </section>
</template>
<script>
export default {
  name: 'ShareBottom',
  props: {
    openApp: {
      type: Function,
      default: () => {}
    }
  }
}
</script>
<style lang="scss" scoped>
.bottom {
  font-size: 0;
  position: relative;
  margin-top: -3rem;
  .btn-con {
    position: relative;
    height: 3rem;
    .gradient {
      display: inline-block;
      width: 100%;
      height: 3rem;
      position: absolute;
      top: 0;
      background-image: linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
    }
    button {
      background: #F6F6F6;
      border-radius: 100px;
      width: 5.9rem;
      height: .8rem;
      font-family: HYQiHei-EZS;
      font-size: .28rem;
      color: #444444;
      letter-spacing: 0;
      text-align: center;
      position: absolute;
      bottom: 0;
      left: .8rem;
      z-index: 3;
      &:active {
        background: rgba(244, 244, 244, .5);
      }
    }
  }
  .bg {
    position: relative;
    width: 100%;
    z-index: 1;
  }
}
</style>
